
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[serviceId]",
      function () {
        return require("private-next-pages/service/[serviceId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[serviceId]"])
      });
    }
  